export default __webpack_public_path__ + "static/media/token_sOHM.52ba04d1.svg";